/** @file nextSlot: the slot an arrow key moves the Art selection to (tiles left/right, entries up/down). */
import type { ArtSlot } from './artTypes';

/** An arrow direction of the slot grid. */
export type SlotStep = 'left' | 'right' | 'up' | 'down';

/**
 * Within one part's slots (rows = entries, columns = tiles): left/right step to the previous / next slot in order,
 * up/down to the same tile (or the nearest one) of the previous / next entry; the first slot when nothing is selected,
 * the current key at an edge, null without slots.
 */
export function nextSlot(slots: readonly ArtSlot[], current: string | null, step: SlotStep): string | null {
  const i = slots.findIndex((s) => s.key === current);
  const here = slots[i];
  if (here === undefined) return slots[0]?.key ?? null;
  if (step === 'left' || step === 'right') return (slots[step === 'left' ? i - 1 : i + 1] ?? here).key;
  const entries = [...new Set(slots.map((s) => s.entry))];
  const target = entries[entries.indexOf(here.entry) + (step === 'up' ? -1 : 1)];
  if (target === undefined) return here.key;
  const row = slots.filter((s) => s.entry === target);
  const best = row.reduce((a, b) => (Math.abs(b.tile - here.tile) < Math.abs(a.tile - here.tile) ? b : a));
  return best.key;
}
